import React from 'react';
import PropTypes from 'prop-types';
import { Transition } from 'react-transition-group';
import { Direction, TRANSITION_DURATION } from './SlideNavigation';
import { SlideGroupContext } from './SlideGroupContext';
import { SlideContext } from './SlideContext';
import { Div } from '../../layouts';

export const Slide = ({ children, id, isDone, isEmpty, onEntered, onExiting }) => {
    const context = React.useContext(SlideGroupContext);
    const [active, setActive] = React.useState(false);
    const [direction, setDirection] = React.useState(Direction.VERTICAL);
    const [enter, setEnter] = React.useState(true);
    const [entered, setEntered] = React.useState(false);

    context.register({ id, isDone, isEmpty, setActive, setDirection, setEnter });

    const _onEntered = () => {
        setEntered(true);
        onEntered();
    };

    const _onExiting = () => {
        setEntered(false);
        onExiting();
    };

    const defaultStyle = {
        position: 'fixed',
        height: '100%',
        width: '100%',
    };

    const transitionStyles = {
        [Direction.HORIZONTAL]: {
            entering: {
                left: '100%',
                zIndex: 7,
            },
            entered: {
                left: 0,
                zIndex: 6,
            },
            exiting: { zIndex: 7 },
            all: {
                ...defaultStyle,
                left: '100%',
                top: 0,
                zIndex: 1,
                transition: `left ${TRANSITION_DURATION}ms ease-in-out`,
            },
        },
        [Direction.VERTICAL]: {
            entering: { top: '100%' },
            entered: { top: 0 },
            all: {
                ...defaultStyle,
                top: '100%',
                zIndex: 5,
                left: 0,
                transition: `top ${TRANSITION_DURATION}ms ease-in-out`,
            },
        },
    };

    return (
        <SlideContext.Provider value={{ entered }}>
            <Transition
                enter={enter}
                in={active}
                timeout={TRANSITION_DURATION}
                onEntered={_onEntered}
                onExiting={_onExiting}
                unmountOnExit
            >
                {(state) => {
                    const styleProps = {
                        ...transitionStyles[direction].all,
                        ...transitionStyles[direction][state],
                    };
                    return (
                        <>
                            <Div {...styleProps}>{children}</Div>
                            <Div {...styleProps} height='100vh' zIndex={4} className='odf-bg-base' />
                        </>
                    );
                }}
            </Transition>
        </SlideContext.Provider>
    );
};

Slide.propTypes = {
    children: PropTypes.node.isRequired,
    id: PropTypes.string.isRequired,
    isDone: PropTypes.bool.isRequired,
    isEmpty: PropTypes.bool.isRequired,
    onEntered: PropTypes.func.isRequired,
    onExiting: PropTypes.func.isRequired,
};
